export default (initialState: InitialStateType) => {
    if (!initialState?.userInfo) {
        return {};
    }
    const { menu, page, button } = initialState.userInfo.access;
    // 菜单中有此路由 或者 pathResult 中有此路由 或者 菜单中有此路由的 owningMenu
    const normalRouteFilter = (route: { path: string }) => {
        const path = route.path.split('?')[0];

        return Boolean(menu[path] || page[path] || path === '/outer/*');
    };
    // 页面内按钮权限
    const buttonAccess = (key: string) => !!button[key];

    return {
        normalRouteFilter,
        buttonAccess,
    };
};
